import script from "./MyAppointement.vue?vue&type=script&setup=true&lang=js"
export * from "./MyAppointement.vue?vue&type=script&setup=true&lang=js"

import "./MyAppointement.vue?vue&type=style&index=0&id=3d0687f3&lang=css"

const __exports__ = script;

export default __exports__